import { ChevronDownIcon, ChevronUpIcon } from "lucide-react";
import { useState } from "react";

interface Props {
  inputData: Record<string, any>;
  dataUncollapsed?: boolean;
}

export const InputData = ({ inputData, dataUncollapsed }: Props) => {
  const [inputDataCollapsed, setInputDataCollapsed] = useState(
    !dataUncollapsed
  );

  return (
    <div className="ml-9 pb-1 pt-4">
      <div className="flex items-center pr-3">
        <h4 className="font-medium text-xs uppercase dark:text-zinc-400 mb-1">
          Input data
        </h4>
        <div className="justify-end flex-1 flex">
          {inputDataCollapsed ? (
            <ChevronDownIcon
              className="text-zinc-500 cursor-pointer"
              onClick={() => setInputDataCollapsed(false)}
            />
          ) : (
            <ChevronUpIcon
              className="text-zinc-500 cursor-pointer"
              onClick={() => setInputDataCollapsed(true)}
            />
          )}
        </div>
      </div>
      {!inputDataCollapsed && (
        <div className="pr-4">
          {Object.keys(inputData).length === 0 ? (
            <p className="dark:text-zinc-400 text-sm">
              There was no input data
            </p>
          ) : (
            <div className="divide-y divide-gray-200 dark:divide-white/10">
              {Object.entries(inputData).map(([key, value], index) => (
                <div key={index} className="flex justify-between py-2">
                  <p className="dark:text-zinc-400 text-sm">{key}</p>
                  <p className="dark:text-white text-sm">
                    {key === "Address"
                      ? `${value.street}, ${value.city}, ${value.country}, ${value.postcode}`
                      : value}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
